/**
 * Encodes an object into a base64 string.
 * @function encodeToBase64
 * @param {Record<string, unknown>} fields - The object to encode.
 * @returns {string} The encoded base64 string.
 */
export const encodeToBase64 = (fields: Record<string, unknown>): string => {
  const jsonString = JSON.stringify(fields);
  const encodedString = btoa(jsonString);
  return encodedString;
};
